import {KeyValueObj} from '../../../../generated/generated-core.model';
import {MxCustomizer} from '../../../mx-customizer';
import {MxGridCustomizerEvent, MxGridExtractId} from '../../mx-grid/services/mx-grid-customizer-event';
import {MxAssignmentGridCustomizerEvent} from './mx-assignment-grid-customizer-event';

export interface AssignmentConfig {
    title?: string;

    keyField?: string;
    displayField?: string;
    extractor?: MxGridExtractId<any>;
    fieldConverter?(inputObject: any): any;
}

export abstract class MxAssignmentGrid implements MxCustomizer<MxAssignmentGridCustomizerEvent> {
    // TODO BoCustomizable<BoGridCustomizerEvent> or BoCustomizable<MxReportViewCustomizerEvent>;
    assignmentComponent: MxCustomizer<MxGridCustomizerEvent>;

    mapAssigmentToField(item: any, assignmentConfig: AssignmentConfig): KeyValueObj {
        let entry: KeyValueObj = new KeyValueObj();
        entry.key = item[assignmentConfig.keyField];
        entry.value = item[assignmentConfig.displayField];
        return entry;
    }

    abstract onCustomize(event: MxAssignmentGridCustomizerEvent): void;
}

export interface AssignmentResult {
    assignedItems: Array<any>;
    assignedItemsKeys: Array<string | number>;
    assignmentConfig?: AssignmentConfig;
    entryFields: Array<KeyValueObj>;
}

